import axios from 'axios'

const state = {
  token: localStorage.getItem('user-token') || '',
  status: ''
}

// getters
const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status
}

// actions
const actions = {
  'AUTH_REQUEST': ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => { // The Promise used for router redirect in login
      axios({ url: 'login_check', data: user, method: 'POST' })
        .then(resp => {
          const token = resp.data.token
          localStorage.setItem('user-token', token) // store the token in localstorage
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
          commit('AUTH_SUCCESS', { token: token, username: user.username })
          resolve(resp)
        })
        .catch(err => {
          commit('AUTH_ERROR', err)
          // if the request fails, remove any possible user token if possible
          localStorage.removeItem('user-token')
          reject(err)
        })
    })
  },
  'AUTH_LOGOUT': ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit('AUTH_LOGOUT')
      localStorage.removeItem('user-token') // clear your user's token from localstorage
      delete axios.defaults.headers.common['Authorization']
      state.status = ''
      state.token = ''
      resolve()
    })
  }
}

const mutations = {
  'AUTH_REQUEST': (state) => {
    state.status = 'loading'
  },
  'AUTH_SUCCESS': (state, data) => {
    state.status = 'success'
    state.token = data.token
    state.username = data.username
  },
  'AUTH_ERROR': (state) => {
    state.status = 'error'
  },
  'AUTH_LOGOUT': (state) => {
    state.status = ''
    state.token = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js